import React from 'react';
import './PaymentSuccessPopup.css';

interface PaymentSuccessPopupProps {
  isOpen: boolean;
  billId: string;
  message?: string;
  onClose: () => void;
}

const PaymentSuccessPopup: React.FC<PaymentSuccessPopupProps> = ({ 
  isOpen, 
  billId, 
  message = 'Giao dịch thanh toán đã được xác nhận thành công',
  onClose 
}) => {
  if (!isOpen) return null;

  return (
    <div className="payment-success-popup-overlay" onClick={onClose}>
      <div className="payment-success-popup" onClick={(e) => e.stopPropagation()}>
        <div className="payment-success-popup-header">
          <div className="payment-success-icon">✓</div>
          <h2>Thanh toán thành công</h2>
          <button className="payment-success-popup-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="payment-success-popup-content">
          <div className="payment-success-message">
            <p>{message}</p>
          </div>

          <div className="payment-success-bill-info">
            <div className="payment-success-bill-label">Mã đơn hàng:</div>
            <div className="payment-success-bill-id">{billId}</div>
          </div>

          <div className="payment-success-note">
            <p>
              Các ô đã được cập nhật vào tài khoản của bạn. 
              Bạn có thể chỉnh sửa và quản lý các ô này ngay bây giờ.
            </p>
          </div>
        </div>

        <div className="payment-success-popup-footer">
          <button className="payment-success-ok-btn" onClick={onClose}>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPopup;

